import h from '../h';
export default function Layout(_ref) {
  var styles = _ref.styles,
      width = _ref.width,
      height = _ref.height,
      offsetY = _ref.offsetY,
      thickWidth = _ref.thickWidth,
      maxTextWidth = _ref.maxTextWidth;
  var x0 = thickWidth / 2;
  var W = width - thickWidth;
  var H = height - thickWidth;
  return h("g", null, h("rect", {
    x: x0,
    y: x0,
    width: W,
    height: H,
    style: styles.box
  }), h("line", {
    x1: 0,
    x2: width,
    y1: offsetY - x0,
    y2: offsetY - x0,
    style: styles.bline
  }), h("line", {
    x1: maxTextWidth,
    x2: width,
    y1: offsetY / 2,
    y2: offsetY / 2,
    style: styles.line
  }));
}